import { OfferModel } from '../model/OfferModel';

interface TitleDefinition {
    enquiry: string;
    order: string;
}

export const selectEntityNameForOffer = (offer: OfferModel, titleDefinition: TitleDefinition) => {
    if (offer.isOrder()) {
        return titleDefinition.order;
    }

    return titleDefinition.enquiry;
};
